import React, { FC } from 'react';
import { ui } from 'util/ui';
import { CrossIcon } from './Icons';

/** The one close (×) button used by every pop-up, so they all match (Aaron, 5 Nov 2026). */
const CloseButton: FC<{ label?: string; onClick(): void; dark?: boolean }> = ({ label = 'Close', onClick, dark }) => (
  <button
    type="button"
    className={dark ? 'archy-close-dark' : 'archy-close'}
    aria-label={label}
    title={label}
    onClick={onClick}
    style={{
      width: 36,
      height: 36,
      flex: 'none',
      border: 'none',
      borderRadius: 10,
      background: 'transparent',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 0,
    }}
  >
    <CrossIcon size={16} color={dark ? '#FFFFFF' : ui.text2} width={2.4} />
  </button>
);

export default CloseButton;
